createCatchHandler